/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { ENVIRONMENT } from 'config';
import store from 'store/index';
import { SLICE } from 'modules/dashboard/constants';
import logger from 'modules/common/utils/logger';
import { updateUserActiveness } from './active-user-time';

let sessionId;
let user;

const writeLog = (filterName, filters) => {
  if (!sessionId) {
    store?.subscribe(() => {
      sessionId = store?.getState()[SLICE.BASE_AUTH]?.sessionId;
      user = store?.getState()[SLICE.BASE_AUTH]?.user;
    });
    sessionId = store?.getState()[SLICE.BASE_AUTH]?.sessionId;
    user = store?.getState()[SLICE.BASE_AUTH]?.user;
  }

  let filterLog = `${filterName} : ${new Date().toISOString()} - `;

  filters.forEach((filter) => {
    if (filter?.$schema?.includes('basic')) {
      filterLog = filterLog?.concat(
        `{table: '${filter?.target?.table}', column : '${filter?.target?.column}'} '${
          filter?.operator
        }' [${filter?.values?.join(',')}] | `
      );
    } else {
      let advancedCondition = '';
      filter?.conditions?.forEach((con) => {
        advancedCondition = advancedCondition?.concat(
          `{operator: '${con.operator}', value: '${con.value}'} `
        );
      });
      filterLog = filterLog?.concat(
        `{table: '${filter?.target?.table}', column : '${filter?.target?.column}'} '${filter?.logicalOperator}' [${advancedCondition}] | `
      );
    }
  });

  if (ENVIRONMENT.PBI_EMBED_DEBUG_MODE?.toLowerCase() === 'true') {
    // eslint-disable-next-line no-console
    console.log(filterLog);
  }

  if (user?.username) {
    logger.setUser({ username: user.username });
  }

  logger.logEvent({
    name: 'pbi_filter_log',
    level: 'info',
    context: {
      sessionId,
      visualType: 'filter',
      filterName,
      message: filterLog,
    },
  });

  // this will send a signal to update the current chunk as active
  updateUserActiveness();
};

export default writeLog;
